import { createFileRoute } from '@tanstack/react-router';

import { BloodReportViewPage } from '@/pages/blood-report/view';

export const Route = createFileRoute('/blood-report/_role-guard/$id/view')({
  component: BloodReportViewPage,
});
